// extracted by mini-css-extract-plugin
export default {"gridContainer":"Clients_gridContainer__feM-n","btn":"Clients_btn__2bnkr","fileInput":"Clients_fileInput__eE16s"};